import "./FeedbackButton.css";

/**
 * 좌측 하단 피드백 버튼. 우측 하단 '책 추가' 와 대칭으로 놓는다.
 *
 * 누르면 기기의 메일 앱이 열리고 수신자·제목이 채워진다.
 * 책 추가가 주 동작이므로 이쪽은 테두리만 있는 형태로 무게를 낮춘다.
 */
const TO = "girlgggg@naver.com";
const SUBJECT = "[MUROO] 피드백";
const BODY = "불편했던 점이나 있었으면 하는 기능을 편하게 적어주세요.\n\n";

const FeedbackButton = () => (
  <a
    className="feedback-fab"
    href={`mailto:${TO}?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(BODY)}`}
    // 메일 앱이 없는 기기에서는 아무 일도 일어나지 않는다.
    // 주소를 title 에 두어 길게 눌러 복사할 수 있게 한다.
    title={`피드백 보내기 · ${TO}`}
    aria-label={`피드백 남기기 (${TO} 으로 메일)`}
  >
    <span className="feedback-fab-icon" aria-hidden="true">✉</span>
    <span className="feedback-fab-label">피드백</span>
  </a>
);

export default FeedbackButton;
